import React from 'react';
import PropTypes from 'prop-types';
import { Price, PriceBeforeDiscount, StyledAmountInfo } from './styles';

export const Pricing = ({ discountedAmount, amount, period }) => {
  return (
    <>
      {discountedAmount !== 'FREE' ? (
        <StyledAmountInfo>
          <PriceBeforeDiscount>{amount}</PriceBeforeDiscount>
          <Price>
            {discountedAmount}
            {period && `/${period}`}
          </Price>
        </StyledAmountInfo>
      ) : (
        <StyledAmountInfo>
          <Price>{discountedAmount}</Price>
        </StyledAmountInfo>
      )}
    </>
  );
};

Pricing.propTypes = {
  amount: PropTypes.string.isRequired,
  discountedAmount: PropTypes.string.isRequired,
  period: PropTypes.string,
};
